import { get } from '../request';
import { APP_CONFIG } from '../../config';
import type { UserAccountDetailsResponse } from '../../@types/userAccount';
import { ApiEndpoints } from '../apiEndpoints.constant';

export const getUserAccountDetails = async (): Promise<UserAccountDetailsResponse> => {
  return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.userAccount}`);
};
